import { gql } from '@apollo/client'

export const API_TOKENS_LIST = gql`
  query API_TOKENS_LIST($pagination: PaginationInput) {
    apiTokens(pagination: $pagination) {
      pagination {
        pageTake
        pageSkip
        totalCount
      }
      data {
        id
        token
        createdAt
      }
    }
  }
`
